import { redirect } from 'react-router-dom';

import ChangePassword from '../components/ChangePassword';
import { getAuthToken } from '../util/auth.jsx'
import { isEqualsToOtherValue } from '../util/validation.jsx'
import backend from '../util/backend.jsx';

function ChangePasswordPage() {
  return <ChangePassword />;
}

export default ChangePasswordPage;

export async function action({ request }) {
  const data = await request.formData();

  const password = data.get('new-password');
  const password2 =  data.get('verify-password');

  const errors = [];

  const passwordsMatch = isEqualsToOtherValue(password, password2);
  if (!passwordsMatch) {
    errors.push("Passwords do not match");
  }

  if (errors.length > 0) {
    return {errors: errors};
  }

  const original_password = data.get('password');
  const changeData = {
    password: original_password,
    new_password: password,
  };

  const token = getAuthToken();
  const response = await fetch(`https://${backend}/changepassword`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(changeData)
  });
  const result = await response.json();

  if (response.status === 422 || response.status === 401) {
    return {errors: [result.message]};
  }

  if (!response.ok) {
    return {errors: ['Could not authenticate.']};
  }

  return redirect('/');
}
